import * as api from "../Api/index";

export const getBranchStats = () => async (dispatch) => {
  try {
    const { data } = await api.branchStats();
    dispatch({ type: "GET_ALL_BRANCH_STATS", payload: data });
  } catch (error) {}
};
